enum AttributionWebVisitsGraphReport {
  AverageImpressions = 'attribution_web_visits_graph_average_impressions',
  DigitalChannel = 'attribution_web_visits_graph_digital_channel',
  DeviceType = 'attribution_web_visits_graph_device_type',
  CampaignName = 'attribution_web_visits_graph_campaign_name',
  Creative = 'attribution_web_visits_graph_creative',
  PublisherName = 'attribution_web_visits_graph_publisher_name',
}

export default AttributionWebVisitsGraphReport;
